import { Box, Stack, Theme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles, useTheme } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Catalog from '../../../../../../api/db/Catalog'
import pubsub from '../../../../../../modules/pubsub'
import { IInventoryItemBrand } from '../../../../../../shared/types'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import Table from '../Table'

export default function ContentBody() {

    const [loading, setLoading] = useState(true)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    const [productBrands, setProductBrands] = useState<IInventoryItemBrand[]>([])
    const theme:Theme = useTheme()

    useEffect(()=>{

        pubsub.on("brand-list:changed", getProductBrands)

        getProductBrands()

        return ()=>pubsub.off("brand-list:changed", getProductBrands)
        
        // eslint-disable-next-line
    },[])
    
    const getProductBrands = async ()=>{
        
        try {
            
            setLoading(true)
            const res:IInventoryItemBrand[] = await Catalog.getBrands(user_id, current_shop)
            setProductBrands(res)
            setLoading(false )
            
        } catch (error) {
            setLoading(false )
            throw error
        }
        
    }

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()
    
    return (
        <>
            {
                loading ? (

                    <BodySkeleton />
                    
                ):(
                    <Box className={classes.content} >

                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >

                            <Table 
                                title="Brands catalog"
                                tableBodyData={productBrands}
                                tableHeadData={["Date", "Name", "Gross revenue", "Gross profit"]}
                                handleItemClick={()=>{}}
                            />

                        </Stack>

                        
                    </Box>
                )
            }
        </>
    )
}
